import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

interface SessionTimeoutModalProps {
  open: boolean;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({
  open,
  onStayLoggedIn,
  onLogout,
}) => {
  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>Session Expiring Soon</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You've been inactive for a while. You'll be logged out in 5 minutes
          due to inactivity.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} color="inherit">
          Log out
        </Button>
        <Button onClick={onStayLoggedIn} variant="contained" autoFocus disableRipple>
          Stay logged in
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionTimeoutModal;